export const songVideoTextFieldStyles = {
  grow: {
    flexGrow: 1,
  },
};
